import "./App.css";
import AppLayout from "./components/layout/AppLayout";

function App() {
//   const [collapsed, setCollapsed] = useState(false);

//   const sections = SECTIONS.map(({ id, label }) => ({ id, label }));

  return (
    <div>
        <AppLayout/>
    </div>
  );
}

export default App;